var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReception(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.84 25.876c-2.274 1.234-8.12-4.352-8.867-5.294-.746-.94-5.098-.194-5.098-.194            m0-10.263s5.228 2.24 10.945 2.533            m.422 10.035s2.793 2.664 3.085 2.956c.292.292 1.883.586 2.046-1.071            m-2.793-2.924s2.793 2.663 3.086 2.955c.292.293 1.883.586 2.046-1.071            m-3.248-3.182s2.793 2.663 3.085 2.955c.292.292 1.883.584 2.046-1.072            0 0-3.215-4.385-6.69-6.69            0 0-1.234.324-1.884.39            0 0-1.851 1.85-2.988 1.104-1.136-.748-.292-3.02 1.786-4.385            2.08-1.363 3.183-1.396 4.807-.585            1.624.813 3.28 1.3 4.255.52            .974-.778 3.118-1.397 6.203-1.072            m0 9.841s-2.63.195-3.833-.389c-1.201-.585-1.407-.373-1.948 0",
    stroke: "#22272A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReception);
export default __webpack_public_path__ + "static/media/reception.2dccdd628e7bf094351d23fef157a5a2.svg";
export { ForwardRef as ReactComponent };